import type { FC } from 'react';
import React from 'react';
import { isNumber } from '@alfa-bank/site-invest-common/helpers/numbers/is-number';

import { roundNumber } from '../../../helpers';

import type { TProfitabilityCell } from './models';

export const ProfitabilityCell: FC<TProfitabilityCell> = ({
    Grid,
    ProfitabilityRenderer,
    Text,
    profitabilityPercent,
}) => {
    const hasPercentValue = isNumber(profitabilityPercent);
    const columnsWidth = hasPercentValue ? [null, 8, null] : [null, 0];
    const roundedPercentValue = hasPercentValue ? roundNumber(profitabilityPercent, 2) : null;

    return (
        <>
            <Grid alignment="center" collapse columnsWidth={columnsWidth} justify="start">
                <Text
                    kind={hasPercentValue ? 'caption' : undefined}
                    styler={{ margin: 0 }}
                    view="primary-medium"
                />
                <></>
                {hasPercentValue && (
                    <ProfitabilityRenderer showTrendSymbol value={roundedPercentValue} />
                )}
            </Grid>
        </>
    );
};
